export default class XhrModal {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...XhrModal.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$canvas = null
        this.DOM.$el.addEventListener('click', this.onClick.bind(this))
    }

    onClick(e) {
        e.preventDefault()
        e.stopPropagation()

        if (this.DOM.$el.classList.contains(this.options.classNameIsBusy)) {
            return
        }

        const endpoint = this.DOM.$el.href

        let size = this.DOM.$el.dataset.modalSize ? this.DOM.$el.dataset.modalSize : false;
        this.DOM.$el.classList.add(this.options.classNameIsBusy)

        axios.get(endpoint, { headers: { 'X-Modal': true } }).then(response => {
            this.DOM.$canvas = document.createElement('div')
            this.DOM.$canvas.innerHTML = response.data

            document.body.appendChild(this.DOM.$canvas)

            if (size) {
                this.DOM.$canvas.querySelector(this.options.selectorWindow).classList.add(this.options.classNameSizePrefix + size)
            }

            window.requestAnimationFrame(() => {
                const $modal = this.DOM.$canvas.querySelector(this.options.selectorModal)

                if ($modal && $modal.modal) {
                    $modal.addEventListener(this.options.eventNameModalHide, this.onHide.bind(this), { passive: true })
                    $modal.modal.show()
                }
            })
        }).catch(error => {
            document.dispatchEvent(
                new CustomEvent("feedback:show", {
                    detail: { type: 'main', feedback: {type : 'error', title: 'Something went wrong' }},
                })
            )
        }).finally(() => {
            this.DOM.$el.classList.remove(this.options.classNameIsBusy)
        })
    }

    onHide() {
        if (this.DOM.$canvas) {
            this.DOM.$canvas.remove()
        }
    }
}

XhrModal.prototype.defaults = {
    attrShow: 'xhrModalShow',
    classNameIsBusy: 'is-busy',
    classNameSizePrefix: 'c-modal__window--',
    eventNameModalHide: 'modal:hide',
    selectorModal: '.js-modal',
    selectorWindow: '.c-modal__window',
}